import { css } from "@emotion/react";

export const setBarItemStyle = (
    color: string,
    borderRadius: string,
    hoverColor?: string
) => {
    return css({
        display: "block",
        position: "relative",
        width: "100%",
        height: "8px",
        backgroundColor: color,
        borderRadius,

        "&:before": {
            content: '""',
            position: "absolute",
            inset: "0",
            pointerEvents: "none",
            transition: "background-color 0.3s ease",
            backgroundColor: hoverColor || "transparent",
            borderRadius
        }
    });
};
